import styled from "styled-components";

export const PasosTurnoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: -12px;
`;

export const LineaTarea = styled.hr`
  width: 4px;
  height: ${({ $paso, $distancia, $distancia2, $distancia3 }) =>
    $paso === 0
      ? `${$distancia ? $distancia : "210"}px`
      : $paso === 1
      ? `${$distancia2 ? $distancia2 : "282"}px`
      : $paso === 2
      ? `${$distancia3 ? $distancia3 : "336"}px`
      : `190px`};
  background-color: var(--color-buscarCards-dots-color);
  opacity: 0;
  @keyframes transicion {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  animation: forwards 0.5s transicion;
  animation-delay: 0.5s;
`;

export const CirculoTareaSiguiente = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 100%;
  background-color: var(--color-buscarCards-dots-color);
  opacity: 0;
  @keyframes transicion {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  animation: forwards 0.5s transicion;
  animation-delay: 0.5s;
`;

export const CirculoTareaCentro = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 100%;
  background-color: white;
  position: relative;
  z-index: 1;
  bottom: 16px;
  opacity: 0;
  @keyframes transicion {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  animation: forwards 0.5s transicion;
  animation-delay: 0.5s;
`;
